<template>
  <div v-if="critical.length" class="nt-banner-wrap">
    <div v-for="n in shown" :key="n.id" class="nt-banner" role="alert">
      <i class="fa nt-banner-icon" :class="n.severity === 'critical' ? 'fa-exclamation-circle' : 'fa-exclamation-triangle nt-banner-icon-warning'" aria-hidden="true"></i>
      <div class="nt-banner-text">
        <strong>{{ n.title }}</strong>
        <span v-if="n.body">{{ n.body }}</span>
      </div>
      <div class="nt-banner-actions">
        <button v-if="n.link" type="button" class="nt-banner-btn nt-banner-btn-primary" @click="openItem(n)">Open</button>
        <button type="button" class="nt-banner-btn" @click="dismiss(n)">Dismiss</button>
      </div>
    </div>
    <router-link v-if="critical.length > shown.length" to="/notifications" class="nt-banner-more">
      {{ critical.length - shown.length }} more need attention
    </router-link>
  </div>
</template>

<script>
import { notificationCenter, markNotificationRead } from '../../../utils/notifications'

const BANNER_TYPES = ['template_recategorised', 'template_pending_24h', 'template_category_risk']

// Unread critical notifications (rejected, paused or disabled templates, blocked campaigns),
// re-categorised templates and templates stuck in review, as a banner above every page until
// they're opened or dismissed. Dismissing marks them read.
export default {
  name: 'notification-banner',
  data () {
    return { center: notificationCenter.$data }
  },
  computed: {
    // Critical items, plus the two warnings the PRD (3.8) also wants as a banner.
    critical () {
      return this.center.items.filter(n => !n.is_read && (n.severity === 'critical' || BANNER_TYPES.includes(n.type)))
    },
    shown () {
      return this.critical.slice(0, 2)
    }
  },
  methods: {
    dismiss (n) {
      markNotificationRead(n)
    },
    openItem (n) {
      markNotificationRead(n)
      this.$router.push(n.link)
    }
  }
}
</script>

<style scoped>
/* Lines up with AdminLTE's .content-wrapper, which sits right of the 230px sidebar. */
.nt-banner-wrap { margin-left: 230px; padding: 10px 15px 0; display: flex; flex-direction: column; gap: 8px; transition: margin-left 0.3s ease-in-out; }
.nt-banner { display: flex; align-items: flex-start; gap: 12px; padding: 10px 14px; border: 1px solid #fecdca; background: #fef3f2; border-radius: 8px; color: #7a271a; font-size: 13px; text-align: left; }
.nt-banner-icon { color: #d92d20; font-size: 16px; margin-top: 1px; }
.nt-banner-icon-warning { color: #f79009; }
.nt-banner-text { flex: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.nt-banner-text strong { color: #912018; }
/* The full text is on the notifications page. */
.nt-banner-text span { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; max-height: 3em; }
.nt-banner-actions { display: flex; gap: 6px; flex-shrink: 0; }
.nt-banner-btn { border: 1px solid #fda29b; background: #fff; color: #b42318; border-radius: 8px; padding: 6px 16px; font-size: 13px; font-weight: 600; cursor: pointer; }
.nt-banner-btn-primary { background: #d92d20; border-color: #d92d20; color: #fff; }
.nt-banner-more { font-size: 12px; color: #b42318; padding-left: 4px; }
@media (max-width: 767px) {
  .nt-banner-wrap { margin-left: 0; }
  .nt-banner { flex-wrap: wrap; }
  .nt-banner-text { flex-basis: calc(100% - 30px); }
  .nt-banner-actions { padding-left: 28px; }
  .nt-banner-text span { -webkit-line-clamp: 3; max-height: 4.5em; }
}
</style>

<style>
/* The sidebar collapses to 50px (AdminLTE's sidebar-mini). Unscoped: the class is on <body>. */
@media (min-width: 768px) {
  .sidebar-mini.sidebar-collapse .nt-banner-wrap { margin-left: 50px; }
}
</style>



// WEBPACK FOOTER //
// NotificationBanner.vue?d3d7d984